@if (reset) {
  <div class="confirm-btns-item">
    <button
      appThrottleClick
      class="x_confirm-btn x_secondary"
      [disabled]="disabledReset"
      [attr.e2e-attr]="e2eAttrReset"
      (throttledClick)="onReset()"
    >
      {{ reset | translate }}
    </button>
  </div>
}
@if (optional) {
  <div class="confirm-btns-item">
    <button
      appThrottleClick
      class="x_confirm-btn x_secondary-2"
      [disabled]="disabledOptional"
      [attr.e2e-attr]="e2eAttrOptional"
      (throttledClick)="onOptional()"
    >
      {{ optional | translate }}
    </button>
  </div>
}
@if (submit) {
  <div class="confirm-btns-item">
    <button
      appThrottleClick
      class="x_confirm-btn x_primary"
      [disabled]="disabledSubmit"
      [attr.e2e-attr]="e2eAttrSubmit"
      (throttledClick)="onSubmit()"
    >
      {{ submit | translate }}
    </button>
  </div>
}
